import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { AuthContext, AuthData } from '../../context/auth';

interface Props {
	authData: AuthData;
}

const PolicyholderActions = (props: Props) => {
	const params = useParams();
	const { policyholderId } = params;
	const { authData } = props;
	const { hasPermission } = authData;
	const [searchParams] = useSearchParams();
	searchParams.set('policyholderId', policyholderId);
	return (
		<Box sx={{ display: 'flex' }}>
			{hasPermission('policy.create') &&
				hasPermission('policy.fetch') &&
				hasPermission('quote.fetch') && (
					<Button
						color='primary'
						variant='contained'
						component={Link}
						to={`/startNewApplication?${searchParams.toString()}`}
					>
						Start New Application
					</Button>
				)}
		</Box>
	);
};

function withContext(Component: any) {
	return (props: Omit<Props, 'authData'>) => (
		<AuthContext.Consumer>
			{(authData) => <Component {...props} authData={authData} />}
		</AuthContext.Consumer>
	);
}

export default withContext(PolicyholderActions);
